import {AbstractModel} from './abstract-model';
import {Partner} from './partner/partner';
import {AdvertisingPlatform} from './advertising-platform';

export class Cost extends AbstractModel {
  date: Date | null = null;
  advertisingPlatform: AdvertisingPlatform | null = null;
  partner: Partner | null = null;
  impressions: number | null = null;
  clicks: number | null = null;
  cost: number | null = null;
  costUsd: number | null = null;
  subid: string | null = null;
  tc1: string | null = null;
  tc2: string | null = null;
  tc3: string | null = null;
  tc4: string | null = null;
  type: string | null = null;
  allocated: boolean = false;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.advertisingPlatform) {
      this.advertisingPlatform = new AdvertisingPlatform().deserialize(input.advertisingPlatform);
    }

    if (input.partner) {
      this.partner = new Partner().deserialize(input.partner);
    }

    return this;
  }
}
